<template>
  <div class="event-loader">
    <b-icon
      icon="circle-fill"
      animation="throb"
      font-scale="4"
    />
  </div>
</template>

<script>
export default {
  name: 'Loader',
}
</script>

<style scoped lang="less">
.event-loader {
  display: flex;
  justify-content: center;
  margin: 100px 0 40px 0;
  color: #d5347a;
}
</style>
